<div class="position-fixed sticky-top w-100" style="left: 0; right: 0; z-index: 15000;">
  <app-alerting></app-alerting>
</div>
<app-overview [overviewFilters]="filters.overviewFilters" [searchFunction]="searchTermFunction" (resultsFound)="renderRecords($event, false)"
              [isEmpty]="isEmpty" [facetNameFormatter]="nameFormatter" [facetsLoading]="facetsLoading" [facets]="facets" (filtersCleared)="clearFilters($event)"
              (facetFiltersChanged)="facetFiltersChanged($event)" (loadNextPage)="loadNextPage()"
              [quickViews]="quickViews" [otherFacets]="otherFacets" [specificFacetFiltersTemplate]="specificFacetFilters"
              [virtualScroll]="true" [itemSize]="65" [virtualData]="data" [virtualItemTemplate]="containerItemTemplate" [virtualTrackBy]="trackByRecord">
  <app-overview-navigation-tabs class="tabs" [items]="cargoNavigationTabs"></app-overview-navigation-tabs>
  <app-overview-navigation-tabs [mobile]="true" class="tabs-mobile d-flex align-items-center" [items]="cargoNavigationTabs"></app-overview-navigation-tabs>

  <div class="header-bar d-flex">
    @if (appContext.isAdmin() || appContext.isCargoDeclarant()) {
      <button class="btn btn-link link-primary text-decoration-none px-0" (click)="createConsignmentFromAttachedContainers()">
        <i class="me-xl-2 d-lg-inline-block button-icon fa-light fa-kit fa-pb-container-empty" [style.margin-top.px]="-5"></i>
        <span>Attach empty containers</span>
      </button>
    }
    @if (appContext.isAdmin() || appContext.isCargoImportViewer()) {
      <div class="d-none d-lg-block center-bar ms-3 ps-0 dropdown">
        <button class="btn btn-link link-primary text-decoration-none px-0" (click)="sendDischargeListToTerminal()">
          <i class="me-xl-2 button-icon fa-light fa-paper-plane"></i>
          <span>Send discharge list to terminal</span>
        </button>
      </div>
    }
    @if (appContext.isAdmin() || appContext.isCargoImportViewer()) {
      <div class="d-none d-lg-block center-bar ms-3 ps-0 dropdown">
        <button class="btn btn-link link-primary text-decoration-none px-0" data-bs-toggle="dropdown">
          <i class="me-xl-2 d-lg-inline-block button-icon fa-light fa-arrow-down-to-line"></i>
          <span class="d-none d-xl-inline-block">Download</span>
        </button>
        <ul class="dropdown-menu dropdown-menu-start" style="cursor: pointer">
          <li class="dropdown-item" (click)="downloadDischargeList()">
            Download discharge list
          </li>
          <li class="dropdown-item" (click)="downloadDischargeDifferences()">
            Download discharge differences
          </li>
        </ul>
      </div>
    }
    <div class="sub-text ms-3 align-items-center d-flex">
      <i class="fa fa-fw fa-light fa-xl fa-container-storage me-1"></i>
      <app-loading-icon [loading]="facetsLoading">
        <span>{{ containerCount }}</span>
      </app-loading-icon>
    </div>
  </div>

  <div class="overview-footer position-relative">
    @if (nrOfSelectedContainers) {
      <div class="row bg-light px-1 px-lg-3 pb-3 gy-3 border-top">
        <div class="col-12 col-md-auto col-lg d-flex align-items-center">
          <span class="sub-text me-2">
            <i class="fa fa-fw fa-light fa-xl fa-container-storage"></i>
          </span>
          <span class="d-inline-flex text-nowrap">{{nrOfSelectedContainers}} container{{nrOfSelectedContainers > 1 ? 's' : ''}}</span>
        </div>
        <div class="col ms-auto p-0"></div>
        <div class="col-12 col-sm-6 col-md-auto">
          <button type="button" class="btn btn-outline-secondary" (click)="containerUtils.createConsignment(getSelectedContainers())">Add to new consignment</button>
        </div>
        @if (selectedOverlandedContainers.length) {
          <div class="col-12 col-sm-6 col-md-auto d-sm-flex flex-column align-items-end">
            <button type="button" class="btn btn-outline-danger" (click)="containerUtils.refuseOverlandedContainers(selectedOverlandedContainers)">Refuse overlanded containers</button>
          </div>
        }
      </div>
    }
  </div>
  <div class="empty-container col-12 h-100 d-flex align-items-center justify-content-center flex-column">
    <img src="/assets/new-portvisit/no-results-icon-cargo-import.svg" alt="No consignments found icon" class="mb-2"/>
    <span class="h1 mb-2">Lost at sea...</span>
    @if (filters.overviewFilters.selectedQuickView !== quickViews[0]) {
      @if (hasActiveFacetFilters) {
        <span class="text-secondary">
          <span>Try </span>
          <span class="link-primary underline-primary cursor-pointer" (click)="clearFilters(facetUtils.clearFilters(filters.overviewFilters.term))">clearing the filters</span>
          <span> or go to the </span>
          <span class="link-primary underline-primary cursor-pointer" (click)="filters.overviewFilters.selectedQuickView = quickViews[0]; facetFiltersChanged(filters.overviewFilters)">{{quickViews[0].name}}</span>
          <span> quick view</span>
        </span>
      } @else {
        <span class="text-secondary">
          <span>Try going to the </span>
          <span class="link-primary underline-primary cursor-pointer" (click)="filters.overviewFilters.selectedQuickView = quickViews[0]; facetFiltersChanged(filters.overviewFilters)">{{quickViews[0].name}}</span>
          <span> quick view</span>
        </span>
      }
      <ng-template #emptyAllRecords>
        <span class="text-secondary">
          <span>Try going to the </span>
          <span class="link-primary underline-primary cursor-pointer" (click)="filters.overviewFilters.selectedQuickView = quickViews[0]; facetFiltersChanged(filters.overviewFilters)">{{quickViews[0].name}}</span>
          <span> quick view</span>
        </span>
      </ng-template>
    } @else {
      @if (hasActiveFacetFilters) {
        <span class="text-secondary">
          <span>Try </span>
          <span class="link-primary underline-primary cursor-pointer" (click)="clearFilters(facetUtils.clearFilters(filters.overviewFilters.term))">clearing the filters</span>
        </span>
      } @else {
        <span class="text-secondary">Try adjusting your filters or search term</span>
      }
    }
    <ng-template #defaultEmptyText>
      @if (hasActiveFacetFilters) {
        <span class="text-secondary">
          <span>Try </span>
          <span class="link-primary underline-primary cursor-pointer" (click)="clearFilters(facetUtils.clearFilters(filters.overviewFilters.term))">clearing the filters</span>
        </span>
      } @else {
        <span class="text-secondary">Try adjusting your filters or search term</span>
      }
    </ng-template>
  </div>
</app-overview>

<ng-template #containerItemTemplate let-container>
  <app-container-overview-item
    [container]="container" [term]="searchTerm"
    [depth]="0" [collapsible]="!!container.consignmentDataSummaries?.length"
    [selected]="isRecordSelected(container)"
    (selectionToggled)="toggleRecordSelection(container)">
  </app-container-overview-item>
</ng-template>

<ng-template #specificFacetFilters>
  <div class="col-md-12">
    <app-facet-date-range [ranges]="ranges" [filterName]="'Last updated'" (ngModelChange)="declarationDateChanged($event)"
                          [(ngModel)]="filters.overviewFilters.filters.timeRange"
                          [removable]="false" [filterDisabled]="!!filters.overviewFilters.term"></app-facet-date-range>
  </div>
  <div class="col-12">
    <app-facet-filter-search-field
      [filterName]="'Call reference number'" [inputFormatter]="utils.visitFormatterExtended" [searchFunction]="findVisits"
      [value]="filters.overviewFilters.filters.crn" dataKey="crn" (valueSelected)="crnFilterChanged($event)"
      [selectedValueFormatter]="crnFilterValueFormatter"></app-facet-filter-search-field>
  </div>
  @if (AppContext.isAdmin()) {
    <div class="col-12">
      <app-facet-filter-search-field
        [filterName]="'Cargo declarant'" [inputFormatter]="utils.declarantFormatter" [searchFunction]="findCargoDeclarants"
        [value]="filters.overviewFilters.filters.cargoDeclarant" (valueSelected)="cargoDeclarantFilterChanged($event)"
        [selectedValueFormatter]="cargoDeclarantFilterValueFormatter" [minCharacters]="1"></app-facet-filter-search-field>
    </div>
  }
</ng-template>

<ng-template #allRecordsNoFilters>
  <span class="text-secondary">Try adjusting your filters or search term</span>
</ng-template>

<ng-template #downloadDischargeListModalBody>
  <div class="row">
    <app-form-field label="Call reference number" class="col-12">
      <app-search [(ngModel)]="downloadCrn" placeholder="Search for visit" dataKey="crn"
        required [inputFormatter]="utils.visitFormatter" [resultFormatter]="utils.visitFormatter"
      [minCharacters]="2" [searchFunction]="utils.findVisits" (ngModelChange)="onCrnChange($event?.crn)"></app-search>
    </app-form-field>
    @if (appContext.isAdmin() && downloadVisit) {
      <app-form-field label="Cargo declarant" class="col-12">
        <app-search [(ngModel)]="selectedDeclarant" [options]="downloadVisit.cargoDeclarants" dataKey="fullName"></app-search>
      </app-form-field>
    }
    @if (downloadVisit) {
      <app-form-field label="Terminal" class="col-12">
        <app-search [(ngModel)]="selectedTerminal" [options]="selectableTerminals" dataKey="terminalName"></app-search>
      </app-form-field>
    }
  </div>
</ng-template>

<ng-template #createConsignmentFromAttachedContainersModalBody>
  <app-status-alert type="info" [closeable]="false">
    <span>This action will create a consignment with all empty containers discharged at the terminal</span>
  </app-status-alert>
  <div class="row">
    <app-form-field label="Call reference number" class="col-12">
      <app-search [(ngModel)]="downloadCrn" placeholder="Search for visit" dataKey="crn"
                  required [inputFormatter]="utils.visitFormatter" [resultFormatter]="utils.visitFormatter"
                  [minCharacters]="2" [searchFunction]="utils.findVisits" (ngModelChange)="onCrnChange($event?.crn)"></app-search>
    </app-form-field>
    @if (appContext.isAdmin() && downloadVisit) {
      <app-form-field label="Cargo declarant" class="col-12">
        <app-search [(ngModel)]="selectedDeclarant" [options]="downloadVisit.cargoDeclarants" dataKey="fullName"></app-search>
      </app-form-field>
    }
    @if (downloadVisit) {
      <app-form-field label="Terminal" class="col-12">
        <app-search required [(ngModel)]="selectedTerminal" [options]="selectableTerminals" dataKey="terminalName"></app-search>
      </app-form-field>
      <app-form-field label="Previous ports" class="col-12">
        <app-search required [(ngModel)]="portOfLoading" [options]="selectablePreviousPorts" dataKey="name"></app-search>
      </app-form-field>
    }
  </div>
</ng-template>

<ng-template #downloadDischargeDifferencesModalBody>
  <div class="row">
    <app-form-field label="Call reference number" class="col-12">
      <app-search [(ngModel)]="downloadCrn" placeholder="Search for visit" dataKey="crn"
                  required [inputFormatter]="utils.visitFormatter" [resultFormatter]="utils.visitFormatter"
                  [minCharacters]="2" [searchFunction]="utils.findVisits" (ngModelChange)="downloadCrn = $event?.crn"></app-search>
    </app-form-field>
  </div>
</ng-template>
